/**
 * NECKLACE BUILDER — Production JS for Shopify / ZEST Theme
 * Chain = product image on canvas. Charms = product images, draggable + rotatable.
 */
(function () {
  'use strict';

  const W = 500, H = 520, SEGMENTS = 60, CHARM_R = 45;

  let step = 1;
  let selectedChain = null;
  let placedCharms = [];
  let chainsData = [], charmsData = [];
  let savedDesigns = [];
  let config = {};
  let dragMode = null;
  let dragId = null;
  let selectedCharmId = null;

  const $ = s => document.querySelector(s);
  const $$ = s => document.querySelectorAll(s);

  const elBuilder       = $('#nb-builder');

  try {
    const configEl = $('#nb-config');
    if (configEl) config = JSON.parse(configEl.textContent);
  } catch(e) {}

  function getEmailEndpoint() {
    try {
      if (config && config.emailEndpoint) return config.emailEndpoint;
      if (window.__NB_EMAIL_ENDPOINT) return window.__NB_EMAIL_ENDPOINT;
      return '';
    } catch (e) {
      return '';
    }
  }

  window.__nbSendDesignCopy = async function(email, bundleId) {
    const endpoint = getEmailEndpoint();
    if (!endpoint) { console.log('[NB] Would send to:', email); return true; }

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'design_copy',
          to: email,
          bcc: 'info@onnniii.com',
          from: 'info@onnniii.com',
          subject: 'Your design copy is attached',
          designNote: bundleId
        })
      });

      let data = null;
      try { data = await res.json(); } catch (e) {}

      return !!(res.ok && data && data.ok && data.action === 'design_copy');
    } catch (err) {
      return false;
    }
  };

  window.__nbSendDeletionNotice = async function(bundleId) {
    const endpoint = getEmailEndpoint();
    if (!endpoint) return;

    try {
      await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'design_deleted',
          to: 'info@onnniii.com',
          subject: 'Design deleted ' + bundleId
        })
      });
    } catch (err) {}
  };

  if (!elBuilder) return;

  const elSvg           = $('#nb-svg');
  const elChainPath     = $('#nb-chain-path');
  const elCharmsGroup   = $('#nb-charms-group');
  const elEmptyText     = $('#nb-empty-text');
  const elCanvasHint    = $('#nb-canvas-hint');
  const elChainsList    = $('#nb-chains-list');
  const elCharmsSection = $('#nb-charms-section');
  const elCharmsGrid    = $('#nb-charms-grid');
  const elAddedWrap     = $('#nb-added-wrap');
  const elAddedTags     = $('#nb-added-tags');
  const elCharmCount    = $('#nb-charm-count');
  const elActionStep1   = $('#nb-action-step1');
  const elActionStep2   = $('#nb-action-step2');
  const elBtnToCharms   = $('#nb-to-charms');
  const elBtnBackChains = $('#nb-back-to-chains');
  const elBtnToReview   = $('#nb-to-review');
  const elReviewTotal   = $('#nb-review-total');
  const elRunningTotal  = $('#nb-running-total');
  const elPanelTitle    = $('#nb-panel-title');
  const elPanelSubtitle = $('#nb-panel-subtitle');
  const elReviewOverlay = $('#nb-review-overlay');
  const elDeleteOverlay = $('#nb-delete-overlay');

  try { chainsData = JSON.parse($('#nb-chains-data').textContent); } catch(e) {}
  try { charmsData = JSON.parse($('#nb-charms-data').textContent); } catch(e) {}

  /* ------------------------------------------------------------------ */
  /*  CHAIN CURVE (used for charm initial placement only)               */
  /* ------------------------------------------------------------------ */
  function chainPoint(t) {
    const cx = W / 2, sY = 80, bY = H - 80, cW = W * 0.6;
    return {
      x: cx + (cW / 2) * Math.cos(Math.PI * t + Math.PI / 2),
      y: sY + (bY - sY) * Math.sin((Math.PI * t) / 2 + Math.PI / 4)
    };
  }

  function money(cents) {
    const fmt = config.moneyFormat || '${{amount}}';
    const raw = fmt.replace('{{amount}}', (cents / 100).toFixed(2))
                   .replace('{{amount_no_decimals}}', Math.round(cents / 100))
                   .replace('{{amount_with_comma_separator}}', (cents / 100).toFixed(2).replace('.', ','));
    return raw.replace(/<[^>]*>/g, '');
  }

  /* ------------------------------------------------------------------ */
  /*  RENDER CHAIN — product image on canvas                            */
  /* ------------------------------------------------------------------ */
  let elChainImage = null;

  function renderChain() {
    if (elChainImage) { elChainImage.remove(); elChainImage = null; }
    elChainPath.setAttribute('d', '');
    elChainPath.setAttribute('stroke', 'none');

    if (!selectedChain) {
      elEmptyText.removeAttribute('hidden');
      return;
    }
    elEmptyText.setAttribute('hidden', '');

    if (selectedChain.image) {
      const img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
      img.setAttribute('href', selectedChain.image);
      const imgW = W * 0.85, imgH = H * 0.85;
      img.setAttribute('x', String((W - imgW) / 2));
      img.setAttribute('y', String((H - imgH) / 2));
      img.setAttribute('width', String(imgW));
      img.setAttribute('height', String(imgH));
      img.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      img.setAttribute('pointer-events', 'none');
      elSvg.insertBefore(img, elCharmsGroup);
      elChainImage = img;
    }
  }

  /* ------------------------------------------------------------------ */
  /*  RENDER CHARMS — product images, draggable + rotatable             */
  /* ------------------------------------------------------------------ */
  function renderCharms() {
    elCharmsGroup.innerHTML = '';
    placedCharms.forEach(pc => {
      const rot = pc.rotation || 0;
      const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      g.setAttribute('transform', `translate(${pc.x}, ${pc.y}) rotate(${rot})`);
      g.dataset.instance = pc.instanceId;
      g.style.cursor = 'grab';

      if (pc.data.image) {
        const img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
        img.setAttribute('href', pc.data.image);
        img.setAttribute('x', -CHARM_R);
        img.setAttribute('y', -CHARM_R);
        img.setAttribute('width', CHARM_R * 2);
        img.setAttribute('height', CHARM_R * 2);
        img.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        g.appendChild(img);
      } else {
        const txt = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        txt.setAttribute('text-anchor', 'middle');
        txt.setAttribute('dominant-baseline', 'central');
        txt.setAttribute('font-size', '16');
        txt.setAttribute('fill', '#1a1a1a');
        txt.textContent = pc.data.title.charAt(0);
        g.appendChild(txt);
      }

      const hit = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      hit.setAttribute('r', String(CHARM_R + 6));
      hit.setAttribute('fill', 'transparent');
      g.appendChild(hit);

      if (pc.instanceId === selectedCharmId) {
        const ctrlY = CHARM_R + 18;
        const btnR = 9;
        const btnSpacing = 28;

        const rotL = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        rotL.setAttribute('data-rotate-left', pc.instanceId);
        rotL.setAttribute('style', 'cursor:pointer');
        const rotLC = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        rotLC.setAttribute('cx', String(-btnSpacing)); rotLC.setAttribute('cy', String(ctrlY));
        rotLC.setAttribute('r', String(btnR));
        rotLC.setAttribute('fill', '#fff'); rotLC.setAttribute('stroke', '#bbb'); rotLC.setAttribute('stroke-width', '0.8');
        rotL.appendChild(rotLC);
        const rotLIcon = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        rotLIcon.setAttribute('transform', `translate(${-btnSpacing},${ctrlY})`);
        rotLIcon.setAttribute('d', 'M3,-2 A4.5,4.5 0 1,0 -1,4');
        rotLIcon.setAttribute('fill', 'none'); rotLIcon.setAttribute('stroke', '#777'); rotLIcon.setAttribute('stroke-width', '1.3'); rotLIcon.setAttribute('stroke-linecap', 'round');
        rotL.appendChild(rotLIcon);
        g.appendChild(rotL);

        const closeG = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        closeG.setAttribute('data-close-charm', pc.instanceId);
        closeG.setAttribute('style', 'cursor:pointer');
        const closeC = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        closeC.setAttribute('cx', '0'); closeC.setAttribute('cy', String(ctrlY));
        closeC.setAttribute('r', String(btnR));
        closeC.setAttribute('fill', '#fff'); closeC.setAttribute('stroke', '#bbb'); closeC.setAttribute('stroke-width', '0.8');
        closeG.appendChild(closeC);
        const closeX1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        closeX1.setAttribute('x1', '-3'); closeX1.setAttribute('y1', String(ctrlY - 3));
        closeX1.setAttribute('x2', '3'); closeX1.setAttribute('y2', String(ctrlY + 3));
        closeX1.setAttribute('stroke', '#777'); closeX1.setAttribute('stroke-width', '1.2'); closeX1.setAttribute('stroke-linecap', 'round');
        closeG.appendChild(closeX1);
        const closeX2 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        closeX2.setAttribute('x1', '3'); closeX2.setAttribute('y1', String(ctrlY - 3));
        closeX2.setAttribute('x2', '-3'); closeX2.setAttribute('y2', String(ctrlY + 3));
        closeX2.setAttribute('stroke', '#777'); closeX2.setAttribute('stroke-width', '1.2'); closeX2.setAttribute('stroke-linecap', 'round');
        closeG.appendChild(closeX2);
        g.appendChild(closeG);

        const rotR = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        rotR.setAttribute('data-rotate-right', pc.instanceId);
        rotR.setAttribute('style', 'cursor:pointer');
        const rotRC = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        rotRC.setAttribute('cx', String(btnSpacing)); rotRC.setAttribute('cy', String(ctrlY));
        rotRC.setAttribute('r', String(btnR));
        rotRC.setAttribute('fill', '#fff'); rotRC.setAttribute('stroke', '#bbb'); rotRC.setAttribute('stroke-width', '0.8');
        rotR.appendChild(rotRC);
        const rotRIcon = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        rotRIcon.setAttribute('transform', `translate(${btnSpacing},${ctrlY})`);
        rotRIcon.setAttribute('d', 'M-3,-2 A4.5,4.5 0 1,1 1,4');
        rotRIcon.setAttribute('fill', 'none'); rotRIcon.setAttribute('stroke', '#777'); rotRIcon.setAttribute('stroke-width', '1.3'); rotRIcon.setAttribute('stroke-linecap', 'round');
        rotR.appendChild(rotRIcon);
        g.appendChild(rotR);
      }

      elCharmsGroup.appendChild(g);
    });
    elCanvasHint.hidden = placedCharms.length === 0;
  }

  function renderAddedTags() {
    if (!elAddedTags) return;
    elAddedTags.innerHTML = '';
    if (!placedCharms.length) { if (elAddedWrap) elAddedWrap.hidden = true; return; }
    if (elAddedWrap) elAddedWrap.hidden = false;
    if (elCharmCount) elCharmCount.textContent = placedCharms.length;
    placedCharms.forEach(pc => {
      const tag = document.createElement('div');
      tag.className = 'nb-charm-tag';
      tag.innerHTML = `<span class="nb-charm-tag__name">${pc.data.title}</span><button type="button" class="nb-charm-tag__remove" data-instance="${pc.instanceId}">&times;</button>`;
      elAddedTags.appendChild(tag);
    });
  }

  function getTotal() {
    let t = selectedChain ? selectedChain.price : 0;
    placedCharms.forEach(pc => { t += pc.data.price; });
    return t;
  }

  function updateTotal() {
    const t = getTotal();
    elRunningTotal.textContent = money(t);
    if (elReviewTotal) elReviewTotal.textContent = money(t);
  }

  /* ------------------------------------------------------------------ */
  /*  STEP NAVIGATION                                                   */
  /* ------------------------------------------------------------------ */
  function goToStep(s) {
    step = s;
    $$('.nb-step').forEach(el => {
      el.classList.toggle('is-active', parseInt(el.dataset.step) <= s);
    });
    elChainsList.hidden = s !== 1;
    elCharmsSection.hidden = s !== 2;
    elActionStep1.hidden = s !== 1;
    elActionStep2.hidden = s !== 2;
    if (s === 1) {
      elPanelTitle.textContent = 'Choose Your Chain';
      elPanelSubtitle.textContent = 'Select one chain as the base for your piece.';
    } else {
      elPanelTitle.textContent = 'Add Your Charms';
      elPanelSubtitle.textContent = 'Tap or click on charms to add them. Drag to reposition on the canvas.';
    }
    updateButtons();
  }

  function updateButtons() {
    elBtnToCharms.disabled = !selectedChain;
    elBtnToReview.disabled = placedCharms.length === 0;
  }

  /* ------------------------------------------------------------------ */
  /*  CHAIN SELECTION                                                   */
  /* ------------------------------------------------------------------ */
  elChainsList.addEventListener('click', e => {
    const card = e.target.closest('.nb-chain-card');
    if (!card) return;
    const vid = card.dataset.variantId;
    selectedChain = chainsData.find(c => String(c.variantId) === vid);
    $$('.nb-chain-card').forEach(c => c.classList.remove('is-selected'));
    card.classList.add('is-selected');
    renderChain(); updateTotal(); updateButtons();
  });

  /* ------------------------------------------------------------------ */
  /*  CHARM SELECTION                                                   */
  /* ------------------------------------------------------------------ */
  elCharmsGrid.addEventListener('click', e => {
    const card = e.target.closest('.nb-charm-card');
    if (!card) return;
    const vid = card.dataset.variantId;
    const data = charmsData.find(c => String(c.variantId) === vid);
    if (!data) return;
    const t = 0.2 + Math.random() * 0.6;
    const pt = chainPoint(t);
    const newId = `${data.variantId}-${Date.now()}`;
    placedCharms.push({ instanceId: newId, data, x: pt.x, y: pt.y, rotation: 0 });
    selectedCharmId = newId;
    renderCharms(); renderAddedTags(); updateTotal(); updateButtons();
  });

  if (elAddedTags) {
    elAddedTags.addEventListener('click', e => {
      const btn = e.target.closest('.nb-charm-tag__remove');
      if (!btn) return;
      placedCharms = placedCharms.filter(c => c.instanceId !== btn.dataset.instance);
      renderCharms(); renderAddedTags(); updateTotal(); updateButtons();
    });
  }

  /* ------------------------------------------------------------------ */
  /*  DRAG & DROP + ROTATION (charms only, chains are static)           */
  /* ------------------------------------------------------------------ */
  elSvg.addEventListener('pointerdown', e => {
    const rotLTarget = e.target.closest('[data-rotate-left]');
    if (rotLTarget) {
      e.preventDefault(); e.stopPropagation();
      const id = rotLTarget.getAttribute('data-rotate-left');
      const pc = placedCharms.find(c => c.instanceId === id);
      if (pc) { pc.rotation = (pc.rotation || 0) - 15; renderCharms(); }
      return;
    }

    const rotRTarget = e.target.closest('[data-rotate-right]');
    if (rotRTarget) {
      e.preventDefault(); e.stopPropagation();
      const id = rotRTarget.getAttribute('data-rotate-right');
      const pc = placedCharms.find(c => c.instanceId === id);
      if (pc) { pc.rotation = (pc.rotation || 0) + 15; renderCharms(); }
      return;
    }

    const closeTarget = e.target.closest('[data-close-charm]');
    if (closeTarget) {
      e.preventDefault(); e.stopPropagation();
      const id = closeTarget.getAttribute('data-close-charm');
      placedCharms = placedCharms.filter(c => c.instanceId !== id);
      selectedCharmId = null;
      renderCharms(); renderAddedTags(); updateTotal(); updateButtons();
      return;
    }

    const gEl = e.target.closest('g[data-instance]');
    if (gEl) {
      e.preventDefault(); e.stopPropagation();
      const newId = gEl.dataset.instance;
      if (selectedCharmId !== newId) {
        selectedCharmId = newId;
        renderCharms();
      }
      dragMode = 'move';
      dragId = newId;
      elSvg.setPointerCapture(e.pointerId);
      return;
    }

    if (selectedCharmId) {
      selectedCharmId = null;
      renderCharms();
    }
  });

  elSvg.addEventListener('pointermove', e => {
    if (!dragId || dragMode !== 'move') return;
    const rect = elSvg.getBoundingClientRect();
    const svgX = ((e.clientX - rect.left) / rect.width) * W;
    const svgY = ((e.clientY - rect.top) / rect.height) * H;
    const pc = placedCharms.find(c => c.instanceId === dragId);
    if (!pc) return;

    pc.x = Math.max(CHARM_R, Math.min(W - CHARM_R, svgX));
    pc.y = Math.max(CHARM_R, Math.min(H - CHARM_R, svgY));

    const gEl = elCharmsGroup.querySelector(`g[data-instance="${dragId}"]`);
    if (gEl) gEl.setAttribute('transform', `translate(${pc.x}, ${pc.y}) rotate(${pc.rotation || 0})`);
  });

  elSvg.addEventListener('pointerup', () => { dragMode = null; dragId = null; });
  elSvg.addEventListener('pointerleave', () => { dragMode = null; dragId = null; });

  /* ------------------------------------------------------------------ */
  /*  BUTTONS                                                           */
  /* ------------------------------------------------------------------ */
  elBtnToCharms.addEventListener('click', () => goToStep(2));
  elBtnBackChains.addEventListener('click', () => goToStep(1));

  /* ------------------------------------------------------------------ */
  /*  REVIEW PAGE                                                       */
  /* ------------------------------------------------------------------ */
  elBtnToReview.addEventListener('click', showReview);

  function showReview() {
    const total = getTotal();
    let itemsHtml = '';
    if (selectedChain) {
      itemsHtml += `<div style="display:flex;align-items:center;gap:14px;padding:16px;background:#fff;border-radius:8px;border:1px solid #e8e2d8;margin-bottom:10px">
        <div style="width:48px;height:48px;border-radius:8px;background:#f8f5ef;display:flex;align-items:center;justify-content:center;overflow:hidden;flex-shrink:0"><img src="${selectedChain.image}" width="48" height="48" style="object-fit:contain;border-radius:8px;"></div>
        <div style="flex:1"><div style="font-size:14px;font-weight:500;color:#1a1a1a">${selectedChain.title}</div><div style="font-size:12px;color:#8a8078">Chain</div></div>
        <span style="font-size:15px;font-weight:600;color:#1a1a1a">${selectedChain.priceFormatted}</span>
      </div>`;
    }
    placedCharms.forEach(pc => {
      itemsHtml += `<div style="display:flex;align-items:center;gap:14px;padding:14px 16px;background:#fff;border-radius:8px;border:1px solid #e8e2d8;margin-bottom:8px">
        <div style="width:40px;height:40px;border-radius:8px;background:#f8f5ef;display:flex;align-items:center;justify-content:center;overflow:hidden;flex-shrink:0">
          ${pc.data.image ? `<img src="${pc.data.image}" width="36" height="36" style="object-fit:contain;">` : `<span>${pc.data.title.charAt(0)}</span>`}
        </div>
        <div style="flex:1"><div style="font-size:14px;font-weight:500;color:#1a1a1a">${pc.data.title}</div><div style="font-size:12px;color:#8a8078">Charm</div></div>
        <span style="font-size:14px;font-weight:600;color:#1a1a1a">${pc.data.priceFormatted}</span>
      </div>`;
    });

    const svgClone = elSvg.cloneNode(true);
    svgClone.removeAttribute('id');
    svgClone.style.width = '100%';
    svgClone.style.height = 'auto';
    svgClone.style.touchAction = 'auto';
    svgClone.querySelectorAll('[data-rotate-left],[data-rotate-right],[data-close-charm]').forEach(el => el.remove());

    elReviewOverlay.innerHTML = `
      <header class="nb-builder__header">
        <div style="display:flex;align-items:center;gap:16px;">
          <button type="button" class="nb-builder__back" id="nb-review-back">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M14 9H4m0 0l4-4M4 9l4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <span>Back to Editor</span>
          </button>
          <div class="nb-builder__divider"></div>
          <h2 class="nb-builder__heading">Review Your Design</h2>
        </div>
      </header>
      <div style="max-width:920px;margin:0 auto;padding:48px 24px">
        <div style="text-align:center;margin-bottom:40px">
          <h2 style="font-family:var(--font-heading-family,serif);font-size:28px;font-weight:600;color:#1a1a1a;margin:0 0 8px">Review Your Design</h2>
          <p style="color:#8a8078;font-size:14px;margin:0">Check that everything looks right before adding to cart.</p>
        </div>
        <div class="nb-review-grid" style="display:grid;grid-template-columns:1fr 1fr;gap:40px;align-items:start">
          <div class="nb-review-svg-wrap" style="background:#fff;border-radius:20px;border:1px solid #e8e2d8;overflow:hidden;padding:12px" id="nb-review-svg-wrap"></div>
          <div>
            <div style="font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:1.5px;color:#8a8078;margin-bottom:16px">Your Selections</div>
            ${itemsHtml}
            <div style="display:flex;justify-content:space-between;padding:16px 0;border-top:2px solid #1a1a1a;font-size:18px;font-weight:600;color:#1a1a1a;margin:20px 0 28px"><span>Total</span><span>${money(total)}</span></div>
            <div class="nb-review-actions" style="display:grid;grid-template-columns:minmax(0,0.75fr) minmax(0,1.25fr);gap:10px;width:100%">
              <button type="button" class="nb-btn-secondary" id="nb-review-edit" style="width:100%;min-width:0">← Edit Design</button>
              <button type="button" class="nb-btn-primary" id="nb-review-confirm" style="width:100%;min-width:0;padding-left:10px;padding-right:10px">Confirm & Add to Cart</button>
            </div>
            <p style="font-size:12px;color:#8a8078;margin-top:16px;line-height:1.6;text-align:center">By confirming, your design will be saved and all items will be added to your cart.</p>
          </div>
        </div>
      </div>`;

    elReviewOverlay.querySelector('#nb-review-svg-wrap').appendChild(svgClone);
    elReviewOverlay.hidden = false;

    elReviewOverlay.querySelector('#nb-review-back').addEventListener('click', hideReview);
    elReviewOverlay.querySelector('#nb-review-edit').addEventListener('click', hideReview);
    elReviewOverlay.querySelector('#nb-review-confirm').addEventListener('click', confirmDesign);
  }

  function hideReview() { elReviewOverlay.hidden = true; }

  /* ------------------------------------------------------------------ */
  /*  CART NOTE HELPERS                                                 */
  /* ------------------------------------------------------------------ */
  function buildDesignNote(design) {
    const parts = [`Bundle: ${design.bundleId}`];
    if (design.chain) parts.push(`Chain: ${design.chain.title}`);
    design.charms.forEach((pc, i) => {
      parts.push(`Charm ${i + 1}: ${pc.data.title} (pos ${Math.round(pc.x)},${Math.round(pc.y)}, rot ${pc.rotation || 0}°)`);
    });
    return parts.join(' | ');
  }

  function buildDesignNoteBlock(design) {
    return [
      '[Custom Necklace Design]',
      buildDesignNote(design)
    ].join('\n');
  }

  async function saveDesignToCartNote(design) {
    const designBlock = buildDesignNoteBlock(design);
    const designAttrKey = '_design_' + design.bundleId;

    try {
      const cartRes = await fetch('/cart.js', {
        headers: { 'Content-Type': 'application/json' },
        cache: 'no-store'
      });
      const cart = await cartRes.json();

      const existingNote = (cart && typeof cart.note === 'string') ? cart.note.trim() : '';
      let newNote = existingNote;

      if (existingNote.indexOf(design.bundleId) === -1) {
        newNote = existingNote ? (existingNote + '\n\n' + designBlock) : designBlock;
      }

      const existingAttributes = (cart && cart.attributes && typeof cart.attributes === 'object') ? cart.attributes : {};
      const newAttributes = Object.assign({}, existingAttributes);
      newAttributes[designAttrKey] = buildDesignNote(design);

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          note: newNote,
          attributes: newAttributes
        })
      });

      return true;
    } catch (err) {
      console.warn('Cart note save failed:', err);
      return false;
    }
  }

  /* ------------------------------------------------------------------ */
  /*  CONFIRM DESIGN → ADD TO CART                                      */
  /* ------------------------------------------------------------------ */
  async function confirmDesign() {
    var confirmBtn = elReviewOverlay.querySelector('#nb-review-confirm');
    confirmBtn.disabled = true;
    confirmBtn.textContent = 'Saving…';

    var bundleId = 'NKLC-' + Date.now().toString(36).toUpperCase();

    var design = {
      bundleId: bundleId,
      chain: selectedChain ? Object.assign({}, selectedChain) : null,
      charms: placedCharms.map(function(pc) {
        return Object.assign({}, pc, { data: Object.assign({}, pc.data) });
      })
    };
    savedDesigns.push(design);

    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/cart/add';
    form.style.display = 'none';

    var itemIndex = 0;

    if (selectedChain) {
      var idInput = document.createElement('input');
      idInput.name = 'items[' + itemIndex + '][id]';
      idInput.value = selectedChain.variantId;
      form.appendChild(idInput);

      var qtyInput = document.createElement('input');
      qtyInput.name = 'items[' + itemIndex + '][quantity]';
      qtyInput.value = '1';
      form.appendChild(qtyInput);

      var props = {
        '_bundle_id': bundleId,
        '_bundle_type': 'necklace-chain',
        'Custom Necklace': 'Chain'
      };
      Object.keys(props).forEach(function(key) {
        var p = document.createElement('input');
        p.name = 'items[' + itemIndex + '][properties][' + key + ']';
        p.value = props[key];
        form.appendChild(p);
      });
      itemIndex++;
    }

    placedCharms.forEach(function(pc, idx) {
      var idInput = document.createElement('input');
      idInput.name = 'items[' + itemIndex + '][id]';
      idInput.value = pc.data.variantId;
      form.appendChild(idInput);

      var qtyInput = document.createElement('input');
      qtyInput.name = 'items[' + itemIndex + '][quantity]';
      qtyInput.value = '1';
      form.appendChild(qtyInput);

      var props = {
        '_bundle_id': bundleId,
        '_bundle_type': 'necklace-charm',
        '_charm_position': Math.round(pc.x) + ',' + Math.round(pc.y),
        '_charm_rotation': String(pc.rotation || 0),
        'Custom Necklace': 'Charm ' + (idx + 1)
      };
      Object.keys(props).forEach(function(key) {
        var p = document.createElement('input');
        p.name = 'items[' + itemIndex + '][properties][' + key + ']';
        p.value = props[key];
        form.appendChild(p);
      });
      itemIndex++;
    });

    var returnTo = document.createElement('input');
    returnTo.name = 'return_to';
    returnTo.value = '/cart';
    form.appendChild(returnTo);

    try {
      await sendDesignToMerchant(design);
    } catch (err) {
      console.warn('Design email send failed:', err);
    }

    try {
      await saveDesignToCartNote(design);
    } catch (err) {
      console.warn('Design note save failed:', err);
    }

    document.body.appendChild(form);
    form.submit();
  }

  /* ------------------------------------------------------------------ */
  /*  EMAIL                                                             */
  /* ------------------------------------------------------------------ */
  async function sendDesignToMerchant(design) {
    if (!config.emailEndpoint) {
      console.log('[NB] No email endpoint. Design:', buildDesignNote(design));
      return true;
    }

    const imageData = await captureDesignImage();

    if (!imageData) {
      console.warn('Design image capture returned empty.');
    }

    const res = await fetch(config.emailEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'design_confirmed',
        to: 'info@onnniii.com',
        subject: design.bundleId,
        designNote: buildDesignNote(design),
        designImage: imageData
      })
    });

    let data = null;
    try { data = await res.json(); } catch (e) {}

    if (!(res.ok && data && data.ok && data.action === 'design_confirmed')) {
      throw new Error('design_confirmed request failed');
    }

    return true;
  }

  async function captureDesignImage() {
    try {
      const c = document.createElement('canvas');
      c.width = W * 2;
      c.height = H * 2;

      const ctx = c.getContext('2d');
      ctx.scale(2, 2);

      ctx.fillStyle = '#FDFBF7';
      ctx.fillRect(0, 0, W, H);

      ctx.strokeStyle = 'rgba(90, 83, 74, 0.06)';
      ctx.lineWidth = 1;
      for (let x = 0; x <= W; x += 40) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, H);
        ctx.stroke();
      }
      for (let y = 0; y <= H; y += 40) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(W, y);
        ctx.stroke();
      }

      ctx.beginPath();
      ctx.setLineDash([6, 8]);
      ctx.strokeStyle = 'rgba(212, 206, 196, 0.7)';
      ctx.lineWidth = 2;
      ctx.arc(W / 2, -140, 220, 0.15 * Math.PI, 0.85 * Math.PI, false);
      ctx.stroke();
      ctx.setLineDash([]);

      function loadImage(src) {
        return new Promise(resolve => {
          if (!src) return resolve(null);
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = () => resolve(img);
          img.onerror = () => resolve(null);
          img.src = src;
        });
      }

      if (selectedChain && selectedChain.image) {
        const chainImg = await loadImage(selectedChain.image);
        if (chainImg) {
          const imgW = W * 0.85;
          const imgH = H * 0.85;
          const x = (W - imgW) / 2;
          const y = (H - imgH) / 2;
          ctx.drawImage(chainImg, x, y, imgW, imgH);
        }
      }

      for (const pc of placedCharms) {
        const charmImg = await loadImage(pc.data && pc.data.image ? pc.data.image : '');
        if (!charmImg) continue;

        const size = CHARM_R * 2;
        ctx.save();
        ctx.translate(pc.x, pc.y);
        ctx.rotate(((pc.rotation || 0) * Math.PI) / 180);
        ctx.drawImage(charmImg, -CHARM_R, -CHARM_R, size, size);
        ctx.restore();
      }

      return c.toDataURL('image/png');
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      if (!elReviewOverlay.hidden) { hideReview(); return; }
      if (!elDeleteOverlay.hidden) { elDeleteOverlay.hidden = true; return; }
    }
  });

})();